/**
 * Advisors Archive Page Map script
 */
class FinHub_AdvisorsArchiveMap {
    constructor() {
        this.initState();
    }

    initState() {
        this.advisorArchive = $('.advisor-list-with-map');
        this.advisorMapSection = this.advisorArchive.find('.advisor-map');
        this.map = this.advisorMapSection.find('.map');
        this.mapInstance = false;
        this.markersList = [];
        this.mapOverlayBtn = this.advisorMapSection.find('.map-overlay-button');
        this.mapWrapper = this.advisorMapSection.find('.advisor-map-wrapper');

        if (this.mapOverlayBtn.length) {
            this.initEvents();
            this.initGlobalCallback();
        }
    }

    initEvents() {
        this.mapOverlayBtn.on('click', e => {
            e.preventDefault();

            if (!this.map.hasClass('is-active')) {
                this.map.addClass('is-active');
            }

            if ($('#finhub-gmaps-script').length) {
                window.updateAdvisorsMap();
                return;
            }

            let script = document.createElement('script');
            script.setAttribute('src', this.mapOverlayBtn.attr('data-maps-src'));
            script.setAttribute('id', 'finhub-gmaps-script');
            $(script).appendTo(document.body);
        });
    }

    initGlobalCallback() {
        window.updateAdvisorsMap = () => {
            if (!this.map.hasClass('is-active')) {
                return;
            }

            if (!this.mapInstance) {
                this.mapInstance = new google.maps.Map(document.querySelector('.advisor-map-wrapper'), {
                    zoom: 10
                });

                this.markersList = [];
            } else {
                for (let i = 0; i < this.markersList.length; i++) {
                    this.markersList[i].setMap(null);
                }

                this.markersList = [];
            }

            let finhubAdvisersList = [];
            let adviserItems = $('.block-advisers__item');

            for (let i = 0; i < adviserItems.length; i++) {
                let item = adviserItems.eq(i);

                if (item.attr('data-latitude') && item.attr('data-longitude')) {
                    finhubAdvisersList.push({
                        id: parseInt(item.attr('data-adviser-id'), 10),
                        name: item.attr('data-name'),
                        surname: item.attr('data-surname'),
                        latitude: parseFloat(item.attr('data-latitude')),
                        longitude: parseFloat(item.attr('data-longitude'))
                    });
                }
            }

            for (let i = 0; i < finhubAdvisersList.length; i++) {
                let advisorData = finhubAdvisersList[i];
                let markerItem = new google.maps.Marker({
                    position: {
                        lat: advisorData.latitude,
                        lng: advisorData.longitude
                    },
                    map: this.mapInstance,
                    fhAdviserID: advisorData.id
                });

                markerItem.addListener('click', function () {
                    let adviserID = parseInt(this['fhAdviserID'], 10);
                    $('.block-advisers__item').removeClass('is-highlighted');
                    $('.block-advisers__item[data-adviser-id="' + adviserID + '"]').addClass('is-highlighted');
                    $('.block-advisers__item[data-adviser-id="' + adviserID + '"]')[0].scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                        inline: 'nearest'
                    });
                });

                this.markersList.push(markerItem);
            }

            var bounds = new google.maps.LatLngBounds();

            for (var i = 0; i < this.markersList.length; i++) {
                bounds.extend(this.markersList[i].getPosition());
            }

            if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
                var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.001, bounds.getNorthEast().lng() + 0.001);
                var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.001, bounds.getNorthEast().lng() - 0.001);
                bounds.extend(extendPoint1);
                bounds.extend(extendPoint2);
            }

            this.mapInstance.fitBounds(bounds);
            google.maps.event.trigger(this.mapInstance, 'resize');
        };
    }
}
